import React from 'react';
import clsx from 'clsx';
import { withStyles } from '@material-ui/styles';
import { withRouter } from 'react-router-dom';
import { IconButton } from '@material-ui/core';
import { compose } from 'redux';

import ArrowBackIcon from '@material-ui/icons/ArrowBack';

const styles = theme => ({
  root: {}
});

class BackButton extends React.Component {

  constructor(props) {
    super(props);

    this.onBack = this.onBack.bind(this);
  }

  onBack() {
    const { history } = this.props;
    history.goBack();
  }

  render() {
    const { classes, className, history } = this.props;
    if(history.length <= 1) {
      return <React.Fragment />
    }
    return <IconButton className = { clsx(classes.root, className) }
                       color = { "inherit" }
                       onClick = { this.onBack } >
      <ArrowBackIcon />
    </IconButton>
  }
}
export default compose(withRouter, withStyles(styles))(BackButton)
